import { atomWithStorage } from 'jotai/utils';

import type { SSOImageRepositoryResponse } from '@/shared/api/generated';
import type { ESSOImageStatus } from '@/shared/api/generated/types/ESSOImageStatus';

/**
 * Slide da biblioteca. Estende `SSOImageRepositoryResponse` com `statusId`
 * espelhando o campo `status` do objeto raiz para uso nos cards.
 */
export type LibrarySlide = Required<SSOImageRepositoryResponse> & {
  /** Status do slide (1 = Draft, 2 = Published) — espelha SSOImageRepositoryResponse.status. */
  readonly statusId?: ESSOImageStatus;
};

/**
 * Átomo persistido em localStorage com todos os slides da biblioteca.
 * Fonte de verdade local até integração com backend.
 */
export const slideLibraryAtom = atomWithStorage<LibrarySlide[]>(
  'slide-library',
  [] as LibrarySlide[],
);
slideLibraryAtom.debugLabel = 'slide-libary/slideLibraryAtom';
